import { Form } from './../../services/form';
import { Component, OnInit } from '@angular/core';
import { PasswordModel } from '../../models/password.model';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MeepCardService } from '../../services/meepCard.service';
import { NotificationService } from '../../notification/swal/notification.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.less']
})
export class ChangePasswordComponent extends Form implements OnInit {

  password: PasswordModel = new PasswordModel();
  isDependentPassword: boolean;
  isDependentCardName: boolean;
  isUserPassword: boolean;
  private routeParams: Params;

  ngOnInit() {
    if (this.routeParams['who'] === 'dependentPassword') {
      this.isDependentPassword = true;
    } else if (this.routeParams['who'] === 'dependentCardName') {
      this.isDependentCardName = true;
    } else {
      this.isUserPassword = true;
    }
  }

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService,
    private meepCardService: MeepCardService, private notificationService: NotificationService) {
    super();
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
    });
  }

  private changeDependentPassword() {
    this.meepCardService.changePassword(this.password.senhaNova, this.routeParams['id'])
      .then(() => {
        this.notificationService.showSuccessNotification('Senha Alterada com sucesso!')
          .then(() => {
            this.router.navigate(['general/cartoesDependentes']);
          });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private changeDependentCardName(): any {
    this.meepCardService.changeCardName(this.password.cardName, this.routeParams['meepcard'])
    .then(() => {
      this.notificationService.showSuccessNotification('Apelido alterado com sucesso!')
        .then(() => {
          this.router.navigate(['general/cartoesDependentes']);
        });
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    });
  }

  private changeUserPassword() {
    this.authService.changePassword(this.password)
      .then(() => {
        this.notificationService.showSuccessNotification('Senha Alterada com sucesso!')
          .then(() => {
            this.router.navigate(['general/minhaConta']);
          });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private changeValidFields() {
    if (this.isDependentPassword) {
      this.changeDependentPassword();
    } else if (this.isUserPassword) {
      this.changeUserPassword();
    } else if (this.isDependentCardName) {
      this.changeDependentCardName();
    } else {
      this.notificationService.showErrorNotification('Ocorreu um erro!').then(() => { this.router.navigate(['login']); });
    }
  }

  private checkEqualityPassowrdFields() {
    if (this.password.senhaNova === this.password.confirmarSenhaNova) {
      this.changeValidFields();
    } else {
      this.notificationService.showAlertNotification('As senhas estão diferentes!');
    }
  }

  private checkEqualityCardNameFields() {
    if (this.password.cardName === this.password.cardNameConfirm) {
      this.changeValidFields();
    } else {
      this.notificationService.showAlertNotification('Os nomes estão diferentes!');
    }
  }

  changePassword() {
    if (this.getFormStatus()) {
      if (this.isDependentPassword || this.isUserPassword) {
        this.checkEqualityPassowrdFields();
      } else if (this.isDependentCardName) {
        this.checkEqualityCardNameFields();
      } else {
        this.notificationService.showErrorNotification('Ocorreu um erro!').then(() => { this.router.navigate(['login']); });
      }
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }

  removeCardName() {
    this.meepCardService.changeCardName(null, this.routeParams['meepcard'])
    .then(() => {
      this.notificationService.showSuccessNotification('Apelido removido com sucesso!')
        .then(() => {
          this.router.navigate(['general/cartoesDependentes']);
        });
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/change-password/change-password.component.ts